import { Injectable } from '@angular/core';
import { LoadingService } from '../fi-loading/loading.service';
import { FiBackendService } from '../fi-backend/fi-backend.service';
import { ISiteDesign } from '../models';
import { IFiHttpPromise } from '../to-fi-promise';
import { isDefined } from '../utils';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Injectable()
export class FiSiteDesignService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private userDataService: FiUserDataService,
    ) {}

    getSiteDesigns(): IFiHttpPromise<ISiteDesign[]> {
        return this.fiBackend.fetchData<ISiteDesign[]>('SiteDesign/SiteDesign/GetSiteDesigns');
    }

    getSiteDesignById(id: number): IFiHttpPromise<ISiteDesign> {
        return this.fiBackend.fetchData<ISiteDesign>(`SiteDesign/SiteDesign/GetSiteDesign/${id}`);
    }

    saveSiteDesign(siteDesign: ISiteDesign) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>('SiteDesign/SiteDesign/SaveSiteDesign', siteDesign),
        );
    }

    deleteSiteDesign(siteDesignIdToDelete: number, successorSiteDesignId: number) {
        let url = `SiteDesign/SiteDesign/DeleteSiteDesign/${siteDesignIdToDelete}`;
        if (isDefined(successorSiteDesignId)) {
            url += `?successorSiteDesignId=${successorSiteDesignId}`;
        }
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<void>(url, successorSiteDesignId));
    }

    setDefaultSiteDesign(siteDesignId: number) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>(`SiteDesign/SiteDesign/SetSiteDesignIsDefault/${siteDesignId}`),
        );
    }

    cloneSiteDesign(siteDesignId: number) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>(`SiteDesign/SiteDesign/CloneSiteDesign/${siteDesignId}`),
        );
    }

    savePreferredSiteDesign(siteDesign: ISiteDesign) {
        const promise = this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>(`SiteDesign/SiteDesign/SavePreferredSiteDesign/${siteDesign.Id}`),
        );
        promise.then(() => {
            this.userDataService.updateActiveSiteDesign(siteDesign);
        });
        return promise;
    }
}
